module.exports = __webpack_public_path__ + "static/media/id@3x.c34826fe.png";